
        <div *ngIf="i18nEnabled; else noI18n" class="info jhi-item-count"
            jhiTranslate="global.item-count"
            translateValues="{{i18nValues()}}"
            [attr.translateValues]="i18nValues()">  /* [attr.translateValues] is used to get entire values in tests */
        </div>
        <ng-template #noI18n class="info jhi-item-count">
            Showing {{((page - 1) * itemsPerPage) == 0 ? 1 : ((page - 1) * itemsPerPage + 1)}} -
            {{(page * itemsPerPage) < total ? (page * itemsPerPage) : total}}
            of {{total}} items.
        </ng-template>


// WEBPACK FOOTER //
// ./~/ng-jhipster/src/component/jhi-item-count.component.d.ts.JhiItemCountComponent.html